<template>
  <div>
    <template v-if="info !== null">
      <b-row>
        <b-col class="text-center my-4">
          <h3 class="font-weight-bold d-inline">{{ info.name }}
            <sup class="text-warning">
              <span v-for="star in info.stars" :key="star">
                <b-icon icon="star-fill" />
              </span>
            </sup>
          </h3>
          <h6 class="d-inline ml-2 text-info">{{info.extraStars}}</h6>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-row>
            <b-col sm="4">
              <h6><b v-translate>Gallery</b></h6>
              <div class="carousel-wrapper" v-if="info.images.length">
                <img :src="info.images[0].url" class="print-only" style="width: 100%" />
                <b-card no-body class="noPrint">
                  <b-carousel
                    id="carousel"
                    controls
                    indicators
                    v-if="info.images.length">
                    <b-carousel-slide v-for="(image,imageIndex) in info.images" :key="imageIndex">
                      <template slot="img">
                        <img :src="image.url" class="img-fluid w-100 d-block carousel-img"/>
                      </template>
                    </b-carousel-slide>
                  </b-carousel>
                  <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
                </b-card>
              </div>
            </b-col>
            <b-col sm="8">
              <h6 class="modal-title mt-2"><b v-translate>Description</b></h6>
              <p style="text-align:justify; white-space: pre-line;">{{info.description }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col sm="12">
          <div v-for="(desc, descIndex) in info.descriptions" :key="'desc' + descIndex">
            <h6 class="modal-title">{{ desc.label }}</h6>
            <p v-html="desc.text"></p>
          </div>
        </b-col>
        <b-col>
          <small v-if="info.url">
            <a :href="info.url" target="_blank">{{ info.url }}</a>
          </small>
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col md="12" class="text-center pt-3">
        <b-aspect aspect="10">
          <b-spinner type="grow" :label="$gettext('Loading...')"></b-spinner>
          <p v-translate>Please wait...</p>
        </b-aspect>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
  .print-only {
    display: none!important;
  }
</style>

<script>
import { getHotelInfo } from 'b2b-common/services/api/hotel'

export default {
  name: 'HotelInfo',
  props: ['id', 'inhouse'],
  data () {
    return {
      info: null
    }
  },
  async created () {
    const res = await getHotelInfo({ hotelId: this.id })
    if (res && Array.isArray(res) && res.length) {
      this.info = {}
      for (const key in res[0]) {
        this.$set(this.info, key, res[0][key])
      }
    }
  }
}
</script>
